import Link from "next/link";

export default function BackUrl({ _data, config }: any) {
    let _backpageid: any;
    let _backurl: any = '';
    _backpageid = _data?.pi_flexform?.data?.additional?.lDEF['settings.backPid']['vDEF']

    if (_backpageid != '') {
        let _bdat = config?.pages?.find((pg: any) => {
            return pg?.uid == _backpageid;
        });
        _backurl = _bdat?.slugurl;
    }
    return (
        <>
            {_backurl !== undefined && _backurl != "" ?
                <Link href={_backurl} className="cir-butn icon-200 mb-40"><div className="cont"> <span className="txt fsz-20 fw-bold">Back</span><img alt="" title="" loading="lazy" width="29" height="8" decoding="async" data-nimg="1" className=" mw-100 custom_image  arrow  blog_detail_back_arr" src={`${process.env.NEXT_PUBLIC_SERVER}/fileadmin/arrow.svg`} /></div></Link>
                : null}
        </>
    )
}